import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import DiemLayMauApi from '../../api/DiemLayMauApi';

export const ModalDiemLayMau = (props) => {
    const { register, handleSubmit, reset } = useForm();
    const [show, setShow] = useState(false);
    const [gid, setGid] = useState('');
    const handleClose = () => {
        props.handleClose();
        setShow(false);
    };

    useEffect(() => {
        setGid(props.thongTin.gid);
        reset({
            cat: props.thongTin.cat,
            cec: props.thongTin.cec,
            dungtrong: props.thongTin.dungtrong,
            id3: props.thongTin.id3,
            k2o: props.thongTin.k2o,
            mau_anhhuo: props.thongTin.mau_anhhuo,
            n: props.thongTin.n,
            oc: props.thongTin.oc,
            om: props.thongTin.om,
            p2o5: props.thongTin.p2o5,
            phkcl: props.thongTin.phkcl,
            set: props.thongTin.set,
            tenpd: props.thongTin.tenpd,
            thit: props.thongTin.thit,
        }, [reset])
    }, [props.showEdit]);

    useEffect(() => {
        if (props.showEdit === true) {
            setShow(true);
        }
    }, [props.showEdit]);
    const saveData = (data) => {
        data.Gid = gid;
        data.Geometry=props.thongTin.Geometry;
        if (props.themMoi) {
            DiemLayMauApi.addThongTin(data).then(() => {
                setShow(false);
                props.saveSuccess();
            })
        }
        else {
            DiemLayMauApi.updateThongTin(data).then(() => {
                setShow(false);
                props.saveSuccess();
            })
        }
    }

    return (
        <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Thông tin điểm lấy mẫu đất</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="user" onSubmit={handleSubmit(saveData)}>
                    <input name="Id" hidden={true} ref={register}></input>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">cat</label>
                        <div className="col-sm-4">
                            <input name="cat" type="text" className="form-control" placeholder="cat" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">cec</label>
                        <div className="col-sm-4">
                            <input name="cec" type="text" className="form-control" placeholder="cec" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">dungtrong</label>
                        <div className="col-sm-4">
                            <input name="dungtrong" type="text" className="form-control" placeholder="dungtrong" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">id3</label>
                        <div className="col-sm-4">
                            <input name="id3" type="text" className="form-control" placeholder="id3" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">k2o</label>
                        <div className="col-sm-4">
                            <input name="k2o" type="text" className="form-control" placeholder="k2o" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">mau_anhhuo</label>
                        <div className="col-sm-4">
                            <input name="mau_anhhuo" type="text" className="form-control" placeholder="mau_anhhuo" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">n</label>
                        <div className="col-sm-4">
                            <input name="n" type="text" className="form-control" placeholder="n" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">oc</label>
                        <div className="col-sm-4">
                            <input name="oc" type="text" className="form-control" placeholder="oc" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">om</label>
                        <div className="col-sm-4">
                            <input name="om" type="text" className="form-control" placeholder="om" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">p2o5</label>
                        <div className="col-sm-4">
                            <input name="p2o5" type="text" className="form-control" placeholder="p2o5" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">phkcl</label>
                        <div className="col-sm-4">
                            <input name="phkcl" type="text" className="form-control" placeholder="phkcl" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">set</label>
                        <div className="col-sm-4">
                            <input name="set" type="text" className="form-control" placeholder="set" ref={register} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label">tenpd</label>
                        <div className="col-sm-4">
                            <input name="tenpd" type="text" className="form-control" placeholder="tenpd" ref={register} />
                        </div>
                        <label className="col-sm-2 col-form-label">thit</label>
                        <div className="col-sm-4">
                            <input name="thit" type="text" className="form-control" placeholder="thit" ref={register} />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" size="sm" onClick={handleSubmit(saveData)}>
                    Lưu</Button>
                <Button variant="danger" size="sm" onClick={handleClose}>
                    Hủy</Button>
            </Modal.Footer>
        </Modal>
    )
}
